export default __webpack_public_path__ + "static/media/releve-des-temp-produit.22a35ac7.svg";